import axios from 'axios'

const baseUrl = `${process.env.REACT_APP_BACKEND_HOST}`
const SUGARCOACH_BASE_URL = `${process.env.REACT_APP_BACKEND_HOST}`

const axiosInstance = axios.create()

//요청 가로채기
axiosInstance.interceptors.request.use(
  //요청 보내기전 수행
  async function (config) {
    const recoilValue = localStorage.getItem('recoil-persist')
    // console.log('recoilValue = ', recoilValue)
    if (recoilValue !== null) {
      const parserdRecoilValue = JSON.parse(recoilValue)
      // console.log('tokenInfo = ', parserdRecoilValue?.token)
      if (
        parserdRecoilValue !== null &&
        parserdRecoilValue?.token?.accessToken &&
        parserdRecoilValue?.token?.refreshToken
      ) {
        // config.headers['x-dy-accesstoken'] =
        //   parserdRecoilValue.token.accessToken
        // config.headers['x-dy-refreshToken'] =
        //   parserdRecoilValue.token.refreshToken
      }
    }
    return config
  },
  //오류 요청
  function (err) {
    return Promise.reject(err)
  },
)

export const getManageSettingList = async (param) => {
  const res = await axios.get(`${baseUrl}/v2/admin/manage-setting`, {
    params: param,
  })
  return res
}

export const setManageSetting = async (param) => {
  const res = await axios.post(`${baseUrl}/v2/admin/manage-setting`, param)
  return res
}

export const getCaptchaOptions = async () => {
  const res = await axios.get(`${baseUrl}/v2/admin/manage-setting/captcha`, {
    method: 'GET',
    headers: { Accept: 'application/json' },
  })
  return res
}
